import { setChartId } from '../apps/tech-chart/state/app-state-reducers/chart-id/chart-id.actions';
import { FolderableType } from 'FoldersApp/enums/folderable-type.enum';
import { SelectedFolderableService } from 'FoldersApp/services/selected-folderable.service';
import * as i0 from "@angular/core";
export class SelectedTechChartService extends SelectedFolderableService {
    constructor() {
        super(...arguments);
        this.RESOURCE_TYPE = FolderableType.TECH_CHART;
        this.ITEM_ID_SLICE_KEY = 'chartId';
    }
    clearSelection() {
        super.clearSelection();
        this.store.dispatch(setChartId({
            chartId: undefined,
        }));
    }
}
SelectedTechChartService.ɵfac = /*@__PURE__*/ (() => { let ɵSelectedTechChartService_BaseFactory; return function SelectedTechChartService_Factory(__ngFactoryType__) { return (ɵSelectedTechChartService_BaseFactory || (ɵSelectedTechChartService_BaseFactory = i0.ɵɵgetInheritedFactory(SelectedTechChartService)))(__ngFactoryType__ || SelectedTechChartService); }; })();
SelectedTechChartService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SelectedTechChartService, factory: SelectedTechChartService.ɵfac });
